export default __webpack_public_path__ + "static/crusader_avatar_flag-a64f0e9f147df7fc6d3f861db6abe919.png";